import React, { Component } from 'react';
import { ComboBox, Alert, Confirm, ComPhoto } from '../../../js/ComponentManager'
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import camera from '../../../img/camera.svg';

/* 개발담당:양유빈
 * 화면기능: 매장정보 수정
 * 세부설명:
*/

export class StoreInfo extends Component {
    static displayName = StoreInfo.name;

    constructor(props) {
        super(props);
        this.state = {
            BldList: [],              // 빌딩콤보 리스트
            FlrList: [],              // 층콤보 리스트
            User_Nm: "",
            Photo:"",
            Org_No: "",
            Org_No_Old:"",
            Org_Nm:"",
            Bld_Code: "",
            Flr_Code:"",
            Whole_No_Name: "",
            Pro_Status: "",
            Content: "",
            Title: "매장정보변경안내",
            Org_File_Grp: "",
            Org_File_Name:"",
            RegisterSuccess: false    //수정 완료

        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSave_Click = this.handleSave_Click.bind(this);
        this.handle_BusinessFile = this.handle_BusinessFile.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleConfirm_Click = this.handleConfirm_Click.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
        this.handle_FileDownLoad = this.handle_FileDownLoad.bind(this);
        this.handle_PhotoUpload = this.handle_PhotoUpload.bind(this);
    }
    //초기화
    async componentDidMount() {
        await this.DefaultData();
        if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
            let Data = this.props.ContentState; 
            if (Big3Common.Util.GetContentState(Data, "Org_No", "") !== "" && Big3Common.Util.GetContentState(Data, "Org_Nm", "") !== "") {
                let FileGrpKey = Big3Common.WebStorage.GetSessionStorage(Big3Common.WebStorage.StorageName.FileGrpKey);
                this.setState({
                    Org_No: Data.Org_No,
                    Org_Nm: Data.Org_Nm,
                    Org_File_Grp: FileGrpKey,
                    Org_File_Name: Data.Org_File_Name 
                });
            }
            
        }
    }
    //매장정보 조회
    async CallStoreInfo() {
        try {
            let data = await Big3Common.Get("api/MyPage/MyInfoMgr/GetOrgGroup");
            if (data.codeName === Big3Common.ResultCode.Success) {
                let Data = JSON.parse(data.dataTable);
                return Data;
            }
        }
        catch (e) {
            console.log("componentDidMount: ", e);
        }
        return null;
    }
    handleChange(event) {
        let tagId = event.target.id;
        let value = event.target.value.trim();
   
        if (tagId === "Org_No") {

            let StringText = value.replace(/-/gi, '');
            if (Big3Common.Util.isNumber(StringText) === false) {
                return false;
            }
            this.setState({ [tagId]: value });
        }
        else if (tagId === "Bld_Code") {
            let mapList = [];
            this.TempFlrList.map(data => {
                if (data.bld_code === value) {
                    mapList.push(data);
                }
                return false;
            });
            //층코드 초기화
            this.setState({
                Bld_Code: value,
                FlrList: mapList,
                Flr_Code: "",
                Whole_No_Name: ""
            });
        }
        else {
            this.setState({ [tagId]: value });
        }
        return false;
    }
    handleBlur(event) {
        let tagId = event.target.id;
        if (tagId === "Org_No" && this.state.Org_No !=="") {
            let isCheck = Big3Common.Util.OrgNumberCheck(this.state.Org_No);
            if (!isCheck) {
                this.setState({ Content: "사업자번호 형식이 잘못 되었습니다." });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            else {
                const Org_No = Big3Common.Util.OrgNumberFormat(this.state.Org_No);
                this.setState({ Org_No: Org_No });
            }
        }
    }
    //등록버튼 클릭 후 마이페이 이동
    handleMove_Click() {
        if (this.state.RegisterSuccess) {
            this.props.RenderComponent("MyPage");
        }
    }
    //사업자등록증 다운로드
    handle_FileDownLoad() {
        const file_grp = this.state.Org_File_Grp;
        const wrk_idx = Big3Common.WebConfig.FileDivision.BU;
        const fileName = this.state.Org_File_Name;
        let Url = `api/Common/Common/FileDownLoad/${file_grp}/${wrk_idx}`
        Big3Common.FileDownLoad(Url, fileName);
         
        
    }
    async handleSave_Click() {
        try {
            let Model = {
                Org_No: Big3Common.Util.OrgNumberFormat(this.state.Org_No),
                Org_Nm: this.state.Org_Nm,
                Bld_Code: this.state.Bld_Code,
                Flr_Code: this.state.Flr_Code,
                Whole_No_Name: this.state.Whole_No_Name,
                Org_File_Grp: this.state.Org_File_Grp === "" ? null : this.state.Org_File_Grp,
                Pro_Status: "PR" //검토중
            };
           
            let Data = await Big3Common.Post('api/MyPage/MyInfoMgr/RegisterOrgGrupreq', Model, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({Title:"수정요청 완료", Content: "정보 수정 요청 후 관리자 승인 후 정보가 수정됩니다.(영업일 기준 3일 이내)", RegisterSuccess:true});
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            else {
                this.setState({ Content: Data.message });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
        }
        catch (e) {
            console.log("handleSave_Click: ", e)
        }
        return false;
    }
    async handleConfirm_Click() {
        let isCheck = Big3Common.Util.OrgNumberCheck(this.state.Org_No);
        let isOk = false;
        if (this.state.Org_No.trim().length === 0) {
            this.setState({ Content: "사업자등록번호를 입력하여 주세요." });
        }
        else if (!isCheck) {
            this.setState({ Content: "사업자번호 형식이 잘못 되었습니다." });
        }
        else if (this.state.Org_Nm.trim().length === 0) {
            this.setState({ Content: "상호명을 입력하여 주세요." });
        }
        else if (this.state.Bld_Code.trim().length === 0) {
            this.setState({ Content: "건물을 선택하여 주세요." });
        }
        else if (this.state.Flr_Code.trim().length === 0) {
            this.setState({ Content: "층수를 선택하여 주세요." });
        }
        else if (this.state.Whole_No_Name.length === 0) {
            this.setState({ Content: "호수를 입력하여 주세요." });
        }
        else if (this.state.Org_No !== this.state.Org_No_Old && this.state.Org_File_Grp.trim().length === 0) {
            this.setState({ Content: "사업자번호가 변경되면 사업자등록증을<br/> 다시 등록하셔야 합니다." });
        }
        else {
            isOk = true;
        }
        if (!isOk) {
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        else {
            Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
        }
        return false;
    }
    //사업자 등록증
    handle_BusinessFile(event) {
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["Content", "Title", "BldList", "FlrList"]);
        this.props.RenderComponent('BusinessInfo', StateCopy);
        event.preventDefault();
    }
    //매장사진 등록
    handle_PhotoUpload(event) {
        let StateCopy = Big3Common.WebStorage.StateStorage(this.state, ["Content", "Title", "BldList", "FlrList"]);

        Big3Common.BaseFileUpLoadConfig.FileType = Big3Common.WebConfig.UpLoadFileType.Image;
        Big3Common.BaseFileUpLoadConfig.UpLoadUrl = "api/MyPage/MyInfoMgr/PhotoUpLoad";
        Big3Common.BaseFileUpLoadConfig.RestUrl = "api/MyPage/MyInfoMgr/MyPhotoUpLoad";
        Big3Common.BaseFileUpLoadConfig.Blob = true;
        this.props.RenderComponent('PhotoUpload', StateCopy);
        event.preventDefault();
    } 
    TempFlrList = [];
    async DefaultData() {
        try {
            let Data = await Big3Common.Get("api/Common/Common/BldMgt");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let DataSet = JSON.parse(Data.multiDataTable);
                let BldList = DataSet.BldList;
                this.TempFlrList = DataSet.FlrList;

                
                let user_nm = "";
                let org_no = "";
                let org_nm = "";
                let bld_code = "";
                let flr_code = "";
                let whole_no_name = "";
                let pro_status = "";
                let org_file_grp = "";
                let org_file_name = "";
                let photo = "";
                let StoreInfo = await this.CallStoreInfo();
                if (StoreInfo !== null) {
                    user_nm = StoreInfo[0]["user_nm"];
                    photo = StoreInfo[0]["photo"];
                    org_no = StoreInfo[0]["org_no"];
                    org_nm = StoreInfo[0]["org_nm"];
                    bld_code = StoreInfo[0]["bld_code"];
                    flr_code = StoreInfo[0]["flr_code"];
                    whole_no_name = StoreInfo[0]["whole_no_name"];
                    pro_status = StoreInfo[0]["pro_status"];
                    org_file_grp = StoreInfo[0]["org_file_grp"];
                    org_file_name = StoreInfo[0]["org_file_name"];
                }

                let mapList = [];
                this.TempFlrList.map(data => {
                    if (data.bld_code === bld_code) {
                        mapList.push(data);
                    }
                    return false;
                });

                this.setState({
                    BldList: BldList,
                    FlrList: mapList,
                    User_Nm: user_nm,
                    Photo: photo,
                    Org_No: org_no,
                    Org_No_Old: org_no,
                    Org_Nm: org_nm,
                    Bld_Code: bld_code,
                    Flr_Code: flr_code,
                    Whole_No_Name: whole_no_name,
                    Pro_Status: pro_status,
                    Org_File_Grp: org_file_grp,
                    Org_File_Name: org_file_name,

                });
            }

        }
        catch (e) {
            console.log("DefaultData :", e);
        }
    }
   
    render() {
        return (
            <div>
                <div className="container_box p_b_margin c_padding">
                    <div className="store_img_box" onClick={this.handle_PhotoUpload }>
                        <div className="photo_box">
                            <ComPhoto className="store_img" Photo={this.state.Photo} />
                            <div className="edit_photo"><img src={camera} alt='등록' /></div>
                        </div>
                        <div>매장사진</div>

                    </div>
                    <div className="input_line">
                        <label>사업자등록번호</label>
                        <div className="nc_box">
                            <input type="tel"
                                id="Org_No"
                                className="form-control cn_input"
                                maxLength="12"
                                placeholder="사업자등록번호를 입력하세요.(-는 제외)"
                                value={this.state.Org_No}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur}
                                readOnly
                            />
                            <button type="button" className="cn_button btn_v1" onClick={this.handle_BusinessFile}>사업자등록증<br />첨부</button>
                        </div>
                        {/*onClick={this.handle_FileDownLoad }*/}
                        <div className="file_name_box">
                            <div className="file_name pointer" onClick={this.handle_FileDownLoad }>
                                {this.state.Org_File_Name}
                            </div>
                        </div> 
                    </div>
                    <div className="input_line">
                        <label>상호명</label>
                        <input type="text"
                            id="Org_Nm"
                            className="form-control"
                            maxLength="50"
                            placeholder="상호명을 입력하세요."
                            value={this.state.Org_Nm}
                            onChange={this.handleChange}
                        />
                    </div>
                    <div className="input_line shop_info_select">
                        <label>매장위치</label>
                        <div className="select_box shop_info_select">
                            <ComboBox id="Bld_Code"
                                ComboChange={this.handleChange}
                                emptyText="건물"
                                textName="bld_name"
                                valueName="bld_code"
                                setValue={this.state.Bld_Code}
                                optionList={this.state.BldList}
                            />
                            <ComboBox id="Flr_Code"
                                ComboChange={this.handleChange}
                                emptyText="층수"
                                textName="flr_name"
                                valueName="flr_code"
                                optionList={this.state.FlrList}
                                setValue={this.state.Flr_Code}
                            />
                            <input type="text"
                                className="form-control"
                                id="Whole_No_Name"
                                maxLength="10"
                                placeholder="호수(직접입력)"
                                onChange={this.handleChange}
                                value={this.state.Whole_No_Name}
                            />

                        </div>

                    </div>
                    <div className="input_line">
                        <label>대표자명</label>
                        <input type="text"
                            id="User_Nm"
                            className="form-control"
                            maxLength="10"
                            placeholder="실명을 입력하세요"
                            value={this.state.User_Nm}
                            readOnly
                        />
                    </div>
                    <div className="info_box">
                        <ul>
                            <li style={{ fontWeight: 'bold', color: '#F82020' }}>매장사진은 관리자 승인없이 등록 직후 적용됩니다.</li>
                            <li style={{ fontWeight: 'bold', color: '#F82020' }}>사업자등록번호는 수정할 수 없습니다.변경 시 탈퇴후 재가입 하셔야 합니다.</li>
                            <li>상가의 빌딩, 층수, 호수, 도매명이 변경된 경우 변경된 사업자 등록증을 첨부해 주세요. </li>
                            <li>정보수정 요청 시 관리자 승인 후 반영됩니다. (영업일 기준 3일 이내)</li>
                        </ul>
                    </div>
                </div>
                <div className="catagory_button_box">
                    {
                        this.state.Pro_Status === "PR" ?
                            <button type="button" className="btn_v btn_inactive">관리자 검토중</button> :
                            <button type="button" className="btn_v btn_v1" onClick={this.handleConfirm_Click} >정보수정</button>
                    }
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title={this.state.Title}
                    AlertClick={this.handleMove_Click }
                />
                <Confirm
                    id="ConfirmBox"
                    title="매장정보변경안내"
                    content="매장정보를 변경하시겠습니까?"
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleSave_Click(e);
                    }}
                />

            </div>
        );
    }
}
